// @flow
import React from 'react';
// Components
import ImageGallery from './ImageGallery';
import GiftCardBuyBox from '../../current-order/components/GiftCardBuyBox';
// Types
import type { Product } from '../types';
//Styles
import './GiftCardProductPage.css';
//Helpers
import { scaleConverter } from '../../common';

export type Props = {
  product: Product,
  userId: number,
  isCopiedProductLink: boolean,
  loadingShareableLink: boolean,
  generateProductLink: () => void,
};

const GiftCardProductPage = ({
  product,
  userId,
  isCopiedProductLink,
  loadingShareableLink,
  generateProductLink,
}: Props) => {
  const price = scaleConverter(product.price);
  const listPrice = scaleConverter(product.listPrice);

  const productOnPromotion = listPrice > price;
  const productDiscount = productOnPromotion
    ? ((listPrice - price) / listPrice) * 100
    : null;

  return (
    <div className="gift-card-product-container">
      {/* TODO: Add loading state */}
      <div>
        <ImageGallery
          productName={product.name}
          images={product.images}
          userId={userId}
          productDiscount={productDiscount}
          generateProductLink={generateProductLink}
          isCopiedProductLink={isCopiedProductLink}
          loadingShareableLink={loadingShareableLink}
          isLoading={false}
          productId={product.id}
          isGiftCard={true}
          />
          <div className="gift-card-product-details-main">
            <div>
              <h5 className="main-product-details-title-item">Descrição do Produto</h5>
                {(product.htmlDescription && product.htmlDescription.body) ? (
                  <div dangerouslySetInnerHTML={{ __html: product.htmlDescription.body }} />
                ) : (
                  <>{product.description}</>
                )}
            </div>
          </div>
        </div>
      <GiftCardBuyBox product={product} />
    </div>
  );
};

export default GiftCardProductPage;
